// extracted by mini-css-extract-plugin
export default {"wrapper":"qvhzVsV7DsvAHyFPi98O","big":"BiY0CwJHuHBWNESGgtSR","dropdown":"LYTMkL1Q5cLNPxiIPbUw"};